module.exports = __webpack_public_path__ + "static/img/6.17ead975.png";